import type { LucideIcon } from "lucide-react";
import type { ReactNode } from "react";

/**
 * A section heading on the event page's Media tab, with the icon that names its
 * kind of media: a recording, the documents, the flyers.
 *
 * One component rather than three inline headings, so the recording and the
 * documents cannot drift into different sizes, faces or icon weights the next time
 * one of them is edited. The icon is decorative — the words already say what the
 * section is — so it is hidden from assistive technology.
 */
export default function EventMediaHeading({ icon: Icon, children }: { icon: LucideIcon; children: ReactNode }) {
  return (
    <h2 style={{ display: "flex", alignItems: "center", gap: ".65rem", fontFamily: "Georgia, 'Times New Roman', serif", fontSize: "1.75rem", color: "white", marginBottom: "1.15rem" }}>
      <Icon size={26} strokeWidth={1.8} aria-hidden="true" style={{ color: "#7DEAFF", flex: "0 0 auto" }} />
      {children}
    </h2>
  );
}
